import { useRef, useState } from "react";

export const OTHER = "Other family member";
export const ROLES = ["Grandma", "Grandad", "Mum", "Dad", "Nana", "Grandpa", OTHER];
export const RELATIONSHIPS = ["Son", "Daughter", "Grandson", "Granddaughter",
  "Great-grandson", "Great-granddaughter", "Partner", OTHER];
const LABEL_RE = /^[\p{L}\p{M}0-9 '’.\-&()]+$/u;

export const cleanLabel = (s) => (s || "").replace(/\s+/g, " ").trim();

export const labelError = (s, kind = "role") => {
  const v = cleanLabel(s);
  if (v.length < 2) return kind === "rel" ? "Please tell us their relationship to you." : "Please tell us what your family calls you.";
  if (v.length > 40) return "Please keep this to 40 characters or fewer.";
  if (!/\p{L}/u.test(v) || !LABEL_RE.test(v)) return "Please use letters, spaces, hyphens or apostrophes only.";
  if (v.toLowerCase() === OTHER.toLowerCase()) return kind === "rel" ? "Please enter their actual relationship, e.g. Niece or Godson." : "Please enter the name or relationship your family uses.";
  return null;
};

// value: the saved label; onChange(label, isOther)
export const RelationshipPicker = ({ options, value, onChange, testid, pill, inputLabel, placeholder, errorKind = "role" }) => {
  const [other, setOther] = useState(!!value && !options.includes(value));
  const [touched, setTouched] = useState(false);
  const lastCustom = useRef(value && !options.includes(value) ? value : "");
  const err = other && touched ? labelError(value, errorKind) : null;
  const pick = (r) => {
    if (r === OTHER) { setOther(true); onChange(options.includes(value) ? lastCustom.current : value, true); return; }
    if (other) lastCustom.current = value;
    setOther(false); setTouched(false); onChange(r, false);
  };
  return (
    <div>
      <div className="flex flex-wrap gap-2" data-testid={testid}>
        {options.map((r) => (
          <button key={r} type="button" data-testid={`${testid}-${r}`} aria-pressed={r === OTHER ? other : !other && value === r}
            onClick={() => pick(r)} className={pill(r === OTHER ? other : !other && value === r)}>{r}</button>
        ))}
      </div>
      {other && (
        <div className="mt-4 fade-up">
          <label htmlFor={`${testid}-custom`} className="eyebrow block mb-2">{inputLabel}</label>
          <input id={`${testid}-custom`} data-testid={`${testid}-custom-input`} maxLength={40} autoFocus
            value={value} placeholder={placeholder} aria-invalid={!!err}
            onChange={(e) => onChange(e.target.value, true)} onBlur={() => setTouched(true)}
            className="w-full h-14 px-4 rounded-xl bg-[#1A1222] border border-[#33264A] text-[#EDE6F7] text-lg placeholder:text-base placeholder:text-[#8C84A0] focus:outline-none focus:border-[#8B2CFF]" />
          {err && <p data-testid={`${testid}-custom-error`} role="alert" className="text-[#F3A6C8] mt-2">{err}</p>}
        </div>
      )}
    </div>
  );
};
